import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

/* =========================================================================
 * Fix: "ResizeObserver loop completed with undelivered notifications"
 * O erro é disparado pelo Recharts (ResponsiveContainer) quando o callback do
 * ResizeObserver modifica o layout e o browser não consegue entregar todas as
 * notificações em um único frame.
 *
 * Fix raiz: envelopamos o callback original em requestAnimationFrame.
 * Isso é a solução oficial recomendada (bug conhecido Chromium #809574).
 * Referências:
 *   - https://github.com/recharts/recharts/issues/3615
 *   - https://github.com/mui/material-ui/issues/34948
 * ========================================================================= */
if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      let rafId = 0;
      const wrapped = (entries, observer) => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          rafId = 0;
          callback(entries, observer);
        });
      };
      super(wrapped);
    }
  };
}

// Defesa em profundidade: se ainda vazar, suprimimos o erro especificamente.
const resizeObserverErrorPattern = /^(?:ResizeObserver loop completed with undelivered notifications|ResizeObserver loop limit exceeded)/;
const suppressResizeObserver = (event) => {
  const message = event?.message || event?.reason?.message || "";
  if (resizeObserverErrorPattern.test(message)) {
    event.stopImmediatePropagation?.();
    event.preventDefault?.();
    return true;
  }
  return false;
};
window.addEventListener("error", suppressResizeObserver);
window.addEventListener("unhandledrejection", suppressResizeObserver);
const originalConsoleError = console.error;
console.error = (...args) => {
  if (args[0] && typeof args[0] === "string" && resizeObserverErrorPattern.test(args[0])) return;
  originalConsoleError(...args);
};

// Em DEV, o overlay do react-error-overlay (CRA) intercepta via sua própria fila.
// Escondemos APENAS o iframe de overlay quando o conteúdo for esse erro específico.
if (process.env.NODE_ENV === "development") {
  const hideResizeObserverOverlay = () => {
    const overlays = document.querySelectorAll("body > iframe");
    overlays.forEach((iframe) => {
      try {
        const doc = iframe.contentDocument;
        const text = doc?.body?.innerText || "";
        if (resizeObserverErrorPattern.test(text)) {
          iframe.style.display = "none";
        }
      } catch {
        /* cross-origin — ignora */
      }
    });
  };
  const observer = new MutationObserver(hideResizeObserverOverlay);
  const start = () => observer.observe(document.body, { childList: true, subtree: false });
  if (document.body) start();
  else document.addEventListener("DOMContentLoaded", start);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
